const settings = {
  namespaced: true,

  state: {
    app_focus: false,
  },

  mutations: {
    SET_FOCUS_APP(state, payload) {
      state.app_focus = payload;
    },
  },

  actions: {
    changeFocusApp({ commit }) {
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "visible") {
          commit("SET_FOCUS_APP", true);
        } else {
          commit("SET_FOCUS_APP", false);
        }
      });
    },
  },

  getters: {
    app_focus: (state) => state.app_focus,
  },
};

export default {
  ...settings,
};
